import React from "react";
import { Link } from "react-router-dom";

export default function VolunteerHome() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Volunteer Dashboard</h1>
      <div className="grid gap-3 md:grid-cols-2">
        <Link to="/volunteer/teams" className="p-4 border rounded-xl hover:bg-gray-50 block">
          Manage Teams
        </Link>
        <Link to="/volunteer/checkin" className="p-4 border rounded-xl hover:bg-gray-50 block">
          Check-in Participants
        </Link>
      </div>
    </div>
  );
}
